import React from "react";

// libraries
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// components
import PrimaryButton from "../PrimaryButton";

// styles
import styles from "./SomethingWentWrong.module.scss";

const ContractNotFound = () => {
  const { t } = useTranslation();

  const onReloadClicked = () => {
    window?.location?.reload();
  };

  return (
    <div className={classNames(styles.container)}>
      <h1>{t("lbl_something_went_wrong")}</h1>
      <div className={styles["button_container"]}>
        <PrimaryButton onClick={onReloadClicked}>
          {t("lbl_refresh_the_page")}
        </PrimaryButton>
      </div>
    </div>
  );
};

export default ContractNotFound;
